const hostname = window && window.location && window.location.hostname;

function api_audience(environment = '', isExternal = true) {
  return `http://absuite.${isExternal ? 'external' : 'internal'}.${
    isStringEmpty(environment) ? '' : environment + '.'
  }resource/api`;
}
function isStringEmpty(str) {
  return str === null || str === undefined || str.trim().length === 0;
}
function proxy_logout(environment = '') {
  return `https://myaccess${
    isStringEmpty(environment) ? environment : '-' + environment
  }.standard.com/pkmslogout`;
}
function redirect_uri(encryptedIdentifier) {
  return (
    window.location.href
      .slice(0, -window.location.hash.length || window.location.href.length)
      .slice(0, -window.location.search.length || window.location.href.length) +
    `?encryptedIdentifier=${encodeURIComponent(encryptedIdentifier)}`
  );
}
export function getOAuthProviderVariablesExternal(encryptedIdentifier = 'default') {
  var result = null;
  const mapExternalProviders = setOAuthProviderVariablesExternal(encryptedIdentifier);
  Array.from(mapExternalProviders.entries()).map(([key, value]) => {
    if (hostname.toLowerCase().includes(key)) {
      result = value;
    }
  });
  return result ?? mapExternalProviders.get('default');
}

export function getOAuthProviderVariablesInternal(encryptedIdentifier = 'default') {
  var result = null;
  const mapInternalProviders = setOAuthProviderVariablesInternal(encryptedIdentifier);
  Array.from(mapInternalProviders.entries()).map(([key, value]) => {
    if (hostname.toLowerCase().includes(key)) {
      result = value;
    }
  });
  return result ?? mapInternalProviders.get('default');
}

function setOAuthProviderVariablesExternal(encryptedIdentifier) {
  return new Map([
    [
      'default',
      {
        API_AUDIENCE: api_audience(), // 'http://absuite.external.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: '1x9jxOa3rWNI2mQyTkLE',
        ISAM_DOMAIN:
          'https://conacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_int_1_0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-int/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=https://abbrokerportal-int.allstate.com',
        PROXY_LOGOUT: proxy_logout('int'), // 'https://abbrokerportal-int.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'int',
      },
    ],
    [
      'localhost',
      {
        API_AUDIENCE: api_audience('int'), // 'http://absuite.external.int.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: '1x9jxOa3rWNI2mQyTkLE',
        ISAM_DOMAIN:
          'https://conacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_int_1_0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-int/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=http://localhost:8080',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'int',
      },
    ],
    [
      'dev',
      {
        API_AUDIENCE: api_audience(), // 'http://absuite.external.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: '57kOeoiKDCHgeeYxAg2l',
        ISAM_DOMAIN:
          'https://identity-auth-devb.allstate.com:443/am/oauth2/.well-known/openid-configuration',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-dev/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=https://myaccess-dev.standard.com',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'dev',
      },
    ],
    [
      'dev2',
      {
        API_AUDIENCE: api_audience(), // 'http://absuite.external.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'Twvd5tGUJYqAqh0s8f8y',
        ISAM_DOMAIN:
          'https://conacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_dev_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-dev/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=https://myaccess-dev2.standard.com',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'dev2',
      },
    ],
    [
      'dev3',
      {
        API_AUDIENCE: api_audience(), // 'http://absuite.external.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'Twvd5tGUJYqAqh0s8f8y',
        ISAM_DOMAIN:
          'https://conacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_dev_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-dev/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=https://myaccess-dev3.standard.com',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'dev3',
      },
    ],
    [
      'test',
      {
        API_AUDIENCE: api_audience(), // 'http://absuite.external.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: '57kOeoiKDCHgeeYxAg2l',
        ISAM_DOMAIN:
          'https://conacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_dev_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-dev/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=https://myaccess-test.standard.com',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'test',
      },
    ],
    [
      'int',
      {
        API_AUDIENCE: api_audience('int'), // 'http://absuite.external.int.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: '1x9jxOa3rWNI2mQyTkLE',
        ISAM_DOMAIN:
          'https://conacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_int_1_0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-int/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=https://myaccess-int1.standard.com',
        PROXY_LOGOUT: proxy_logout('int1'), // 'https://abbrokerportal-int.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'int1',
      },
    ],
    [
      'int2',
      {
        API_AUDIENCE: api_audience('int'), // 'http://absuite.external.int.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: '1x9jxOa3rWNI2mQyTkLE',
        ISAM_DOMAIN:
          'https://conacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_int_1_0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-int/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=https://myaccess-int2.standard.com',
        PROXY_LOGOUT: proxy_logout('int2'), // 'https://abbrokerportal-int2.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'int2',
      },
    ],
    [
      'uat',
      {
        API_AUDIENCE: api_audience('uat'), // 'http://absuite.external.uat.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: '2Y3fDWn4RSeI9VoupjnK',
        ISAM_DOMAIN:
          'https://conacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_uat_1_0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-uat/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=https://myaccess-uat.standard.com',
        PROXY_LOGOUT: proxy_logout('uat'), // 'https://abbrokerportal-uat.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'uat',
      },
    ],
    [
      'staging',
      {
        API_AUDIENCE: api_audience('staging'), // 'http://absuite.external.staging.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'kUPKDWmq2fMJFSkUM9sf',
        ISAM_DOMAIN:
          'https://conacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_staging_1_0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-staging/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=https://myaccess-staging.standard.com',
        PROXY_LOGOUT: proxy_logout('staging'), // 'https://abbrokerportal-staging.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'staging',
      },
    ],
    [
      'preprod.allstate',
      {
        API_AUDIENCE: 'http://absuite.external.preprod.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'f9RK8FfPFUZCO0U1H93d',
        ISAM_DOMAIN:
          'https://conacc-np.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_pre-prod_1_0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-np.allstate.com/FIM/sps/schoox-preprod/saml20/',
        LOGOUT: `https://conacc-np.allstate.com/pkmslogout?redirect_uri=${window.location.origin}`,
        PROXY_LOGOUT: `https://conacc-np.allstate.com/pkmslogout?redirect_uri=${window.location.origin}`,
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'preprod',
      },
    ],
    [
      'prod-support.allstate',
      {
        API_AUDIENCE: 'https://AB_Suite_External_Sandbox_3431/audience',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'VqKP5lHbG7j72ZAQeWoB',
        ISAM_DOMAIN:
          'https://conacc-st.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_sandbox_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-st.allstate.com/FIM/sps/schoox-preprod/saml20/',
        LOGOUT: `https://conacc-st.allstate.com/pkmslogout?redirect_uri=${window.location.origin}`,
        PROXY_LOGOUT: 'https://abbrokerportal-prod-support.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'preprod',
      },
    ],
    [
      'airlock',
      {
        API_AUDIENCE: api_audience(), // 'http://absuite.external.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'qPLPMiskmaeHEwTWt06y',
        ISAM_DOMAIN:
          'https://conacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_dev_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-ts.allstate.com/FIM/sps/schoox-dev/saml20/',
        LOGOUT: 'https://conacc-ts.allstate.com/pkmslogout?redirect_uri=https://myaccess-airlock.standard.com',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'airlock',
      },
    ],
    [
      'abbrokerportal.allstate',
      {
        API_AUDIENCE: api_audience('prod'), // 'http://absuite.external.prod.resource/api',
        ENV: 'prod',
        ISAM_CLIENT_ID: '8doFqBDHqkSHsnzl39BW',
        ISAM_DOMAIN:
          'https://conacc.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_prod_1.0',
        ISAM_SCHOOX:
          'https://saml.schoox.com/saml/login?idpUrl=https://conacc.allstate.com/FIM/sps/schoox-prod/saml20/',
        LOGOUT: 'https://conacc.allstate.com/pkmslogout?redirect_uri=https://abbrokerportal.allstate.com',
        PROXY_LOGOUT: proxy_logout(), // 'https://abbrokerportal.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'prod',
      },
    ],
    [
      'myaccess.allstatebenefits',
      {
        API_AUDIENCE: api_audience('prod'), // 'http://absuite.external.prod.resource/api',
        ENV: 'prod',
        ISAM_CLIENT_ID: '8doFqBDHqkSHsnzl39BW',
        ISAM_DOMAIN:
          'https://conacc.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_prod_1.0',
        ISAM_SCHOOX:
          'https://saml.schoox.com/saml/login?idpUrl=https://conacc.allstate.com/FIM/sps/schoox-prod/saml20/',
        LOGOUT: 'https://conacc.allstate.com/pkmslogout?redirect_uri=https://myaccess.allstatebenefits.com',
        PROXY_LOGOUT: 'https://myaccess.allstatebenefits.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'prod',
      },
    ],
    // SIC config starts here...
    [
      'pre-prod.standard',
      {
        API_AUDIENCE: 'https://AB_Suite_External_Sandbox_3431/audience',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'VqKP5lHbG7j72ZAQeWoB',
        ISAM_DOMAIN:
          'https://conacc-pre-prod.standard.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_sandbox_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-st.allstate.com/FIM/sps/schoox-preprod/saml20/',
        LOGOUT: `https://conacc-pre-prod.standard.com/pkmslogout?redirect_uri=${window.location.origin}`,
        PROXY_LOGOUT: 'https://myaccess-pre-prod.standard.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'pre-prod',
      },
    ],
    [
      'pre-prod-fallback.standard',
      {
        API_AUDIENCE: 'https://AB_Suite_External_Sandbox_3431/audience',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'VqKP5lHbG7j72ZAQeWoB',
        ISAM_DOMAIN:
          'https://conacc-pre-prod.standard.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_sandbox_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-st.allstate.com/FIM/sps/schoox-preprod/saml20/',
        LOGOUT: `https://conacc-pre-prod.standard.com/pkmslogout?redirect_uri=${window.location.origin}`,
        PROXY_LOGOUT: 'https://myaccess-pre-prod.standard.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'preprod',
      },
    ],
    [
      'prod-support.standard',
      {
        API_AUDIENCE: 'https://AB_Suite_External_Sandbox_3431/audience',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'VqKP5lHbG7j72ZAQeWoB',
        ISAM_DOMAIN:
          'https://conacc-st.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_sandbox_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://conacc-st.allstate.com/FIM/sps/schoox-preprod/saml20/',
        LOGOUT: `https://conacc-st.allstate.com/pkmslogout?redirect_uri=${window.location.origin}`,
        PROXY_LOGOUT: 'https://myaccess-prod-support.standard.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'preprod',
      },
    ],
    [
      'myaccess.standard',
      {
        API_AUDIENCE: 'http://absuite.external.prod.resource/api',
        ENV: 'prod',
        ISAM_CLIENT_ID: '8doFqBDHqkSHsnzl39BW',
        ISAM_DOMAIN:
          'https://conacc.standard.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite_external_prod_1.0',
        ISAM_SCHOOX:
          'https://saml.schoox.com/saml/login?idpUrl=https://conacc.allstate.com/FIM/sps/schoox-prod/saml20/',
        LOGOUT: 'https://conacc.standard.com/pkmslogout?redirect_uri=https://myaccess.standard.com',
        PROXY_LOGOUT: 'https://myaccess.standard.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'prod',
      },
    ],
  ]);
}

function setOAuthProviderVariablesInternal(encryptedIdentifier) {
  return new Map([
    [
      'default',
      {
        API_AUDIENCE: api_audience('int', false), // 'http://absuite-internal.int.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'aRcKBBTb97aJ91SEL0Bw',
        ISAM_DOMAIN:
          'https://agtacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_int_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-ts.allstate.com/FIM/sps/schoox-int/saml20/',
        LOGOUT: 'https://agtacc-ts.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'int',
      },
    ],
    [
      'localhost',
      {
        API_AUDIENCE: api_audience('int', false), // 'http://absuite-internal.int.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'aRcKBBTb97aJ91SEL0Bw',
        ISAM_DOMAIN:
          'https://agtacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_int_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-ts.allstate.com/FIM/sps/schoox-int/saml20/',
        LOGOUT: 'https://agtacc-ts.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'local',
      },
    ],
    [
      'dev',
      {
        API_AUDIENCE: api_audience('', false), // 'http://absuite-internal.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'mjDMU4PdXgW1prxcvWL5',
        ISAM_DOMAIN:
          'https://auth-deva.allstate.com:443/am/oauth2/.well-known/openid-configuration',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-ts.allstate.com/FIM/sps/schoox-dev/saml20/',
        LOGOUT: 'https://agtacc-ts.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'dev',
      },
    ],
    [
      'dev2',
      {
        API_AUDIENCE: api_audience('', false), // 'http://absuite-internal.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'mjDMU4PdXgW1prxcvWL5',
        ISAM_DOMAIN:
          'https://agtacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_dev_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-ts.allstate.com/FIM/sps/schoox-dev/saml20/',
        LOGOUT: 'https://agtacc-ts.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'dev2',
      },
    ],
    [
      'dev3',
      {
        API_AUDIENCE: api_audience('', false), // 'http://absuite-internal.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'mjDMU4PdXgW1prxcvWL5',
        ISAM_DOMAIN:
          'https://agtacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_dev_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-ts.allstate.com/FIM/sps/schoox-dev/saml20/',
        LOGOUT: 'https://agtacc-ts.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'dev3',
      },
    ],
    [
      'test',
      {
        API_AUDIENCE: api_audience('', false), // 'http://absuite-internal.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'mjDMU4PdXgW1prxcvWL5',
        ISAM_DOMAIN:
          'https://agtacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_dev_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-ts.allstate.com/FIM/sps/schoox-dev/saml20/',
        LOGOUT: 'https://agtacc-ts.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'test',
      },
    ],
    [
      'int',
      {
        API_AUDIENCE: api_audience('int', false), // 'http://absuite-internal.int.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'aRcKBBTb97aJ91SEL0Bw',
        ISAM_DOMAIN:
          'https://agtacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_int_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-ts.allstate.com/FIM/sps/schoox-int/saml20/',
        LOGOUT: 'https://agtacc-ts.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'int1',
      },
    ],
    [
      'int2',
      {
        API_AUDIENCE: api_audience('int', false), // 'http://absuite-internal.int.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'aRcKBBTb97aJ91SEL0Bw',
        ISAM_DOMAIN:
          'https://agtacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_int_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-ts.allstate.com/FIM/sps/schoox-int/saml20/',
        LOGOUT: 'https://agtacc-ts.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'int2',
      },
    ],
    [
      'uat',
      {
        API_AUDIENCE: api_audience('uat', false), // 'http://absuite-internal.uat.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'IsUAGDW4At9ZycFUw4fL',
        ISAM_DOMAIN:
          'https://agtacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_uat_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-ts.allstate.com/FIM/sps/schoox-uat/saml20/',
        LOGOUT: 'https://agtacc-ts.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'uat',
      },
    ],
    [
      'staging',
      {
        API_AUDIENCE: api_audience('staging', false), // 'http://absuite-internal.staging.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'B1GReHxKMvzDTC0wiDL9',
        ISAM_DOMAIN:
          'https://agtacc-ts.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_staging_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-ts.allstate.com/FIM/sps/schoox-staging/saml20/',
        LOGOUT: 'https://agtacc-ts.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'staging',
      },
    ],
    [
      'preprod.allstate',
      {
        API_AUDIENCE: 'http://absuite-internal.preprod.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'YIwSJVN4E0r5j8Y3NWDx',
        ISAM_DOMAIN:
          'https://agtacc-np.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_pre-prod_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-np.allstate.com/FIM/sps/schoox-preprod/saml20/',
        LOGOUT: `https://agtacc-np.allstate.com/pkmslogout?redirect_uri=${window.location.origin}`,
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'pre-prod',
      },
    ],
    [
      'prod-support.allstate',
      {
        API_AUDIENCE: 'http://absuite-internal.sandbox.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'gfEPqno9M8koHcs4bfYI',
        ISAM_DOMAIN:
          'https://agtacc-st.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_sandbox_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-st.allstate.com/FIM/sps/schoox-preprod/saml20/',
        LOGOUT: `https://agtacc-st.allstate.com/pkmslogout?redirect_uri=${window.location.origin}`,
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'prod-support',
      },
    ],
    [
      'abbrokerportal.allstate',
      {
        API_AUDIENCE: api_audience('prod', false), // 'http://absuite-internal.prod.resource/api',
        ENV: 'prod',
        ISAM_CLIENT_ID: '7m6BBmfez6tfdHO1dKVH',
        ISAM_DOMAIN:
          'https://agtacc.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_prod_1.0',
        ISAM_SCHOOX:
          'https://saml.schoox.com/saml/login?idpUrl=https://agtacc.allstate.com/FIM/sps/schoox-prod/saml20/',
        LOGOUT: 'https://agtacc.allstate.com/pkmslogout?redirect_uri=https://abbrokerportal.allstate.com',
        PROXY_LOGOUT: proxy_logout(), // 'https://abbrokerportal.allstate.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'prod',
      },
    ],
    [
      'myaccess.allstatebenefits',
      {
        API_AUDIENCE: api_audience('prod', false), // 'http://absuite-internal.prod.resource/api',
        ENV: 'prod',
        ISAM_CLIENT_ID: '7m6BBmfez6tfdHO1dKVH',
        ISAM_DOMAIN:
          'https://agtacc.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_prod_1.0',
        ISAM_SCHOOX:
          'https://saml.schoox.com/saml/login?idpUrl=https://agtacc.allstate.com/FIM/sps/schoox-prod/saml20/',
        LOGOUT: 'https://agtacc.allstate.com/pkmslogout?redirect_uri=https://myaccess.allstatebenefits.com',
        PROXY_LOGOUT: 'https://myaccess.allstatebenefits.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'prod',
      },
    ],
    // SIC configuration starts here...
    [
      'pre-prod.standard',
      {
        API_AUDIENCE: 'http://absuite-internal.sandbox.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'gfEPqno9M8koHcs4bfYI',
        ISAM_DOMAIN:
          'https://agtacc-pre-prod.standard.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_sandbox_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-st.allstate.com/FIM/sps/schoox-preprod/saml20/',
        LOGOUT: `https://agtacc-pre-prod.standard.com/pkmslogout?redirect_uri=${window.location.origin}`,
        PROXY_LOGOUT: 'https://myaccess-pre-prod.standard.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'pre-prod',
      },
    ],
    [
      'pre-prod-fallback.standard',
      {
        API_AUDIENCE: 'http://absuite-internal.sandbox.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'gfEPqno9M8koHcs4bfYI',
        ISAM_DOMAIN:
          'https://agtacc-pre-prod.standard.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_sandbox_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-st.allstate.com/FIM/sps/schoox-preprod/saml20/',
        LOGOUT: `https://agtacc-pre-prod.standard.com/pkmslogout?redirect_uri=${window.location.origin}`,
        PROXY_LOGOUT: 'https://myaccess-pre-prod.standard.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'preprod',
      },
    ],
    [
      'prod-support.standard',
      {
        API_AUDIENCE: 'http://absuite-internal.sandbox.resource/api',
        ENV: 'nonprod',
        ISAM_CLIENT_ID: 'gfEPqno9M8koHcs4bfYI',
        ISAM_DOMAIN:
          'https://agtacc-st.allstate.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_sandbox_1.0',
        ISAM_SCHOOX:
          'https://stagingsaml.schoox.com/saml/login?idpUrl=https://agtacc-st.allstate.com/FIM/sps/schoox-preprod/saml20/',
        LOGOUT: `https://agtacc-st.allstate.com/pkmslogout?redirect_uri=${window.location.origin}`,
        PROXY_LOGOUT: 'https://myaccess-prod-support.standard.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'prod-support',
      },
    ],
    [
      'myaccess.standard',
      {
        API_AUDIENCE: 'http://absuite-internal.prod.resource/api',
        ENV: 'prod',
        ISAM_CLIENT_ID: '7m6BBmfez6tfdHO1dKVH',
        ISAM_DOMAIN:
          'https://agtacc.standard.com/mga/sps/oauth/oauth20/metadata/allstate_benefits_technology_ab_suite-internal_prod_1.0',
        ISAM_SCHOOX:
          'https://saml.schoox.com/saml/login?idpUrl=https://agtacc.allstate.com/FIM/sps/schoox-prod/saml20/',
        LOGOUT: 'https://agtacc.standard.com/pkmslogout?redirect_uri=https://myaccess.standard.com',
        PROXY_LOGOUT: 'https://myaccess.standard.com/pkmslogout',
        REDIRECT_URI: redirect_uri(encryptedIdentifier),
        SPACE_NAME: 'prod',
      },
    ],
  ]);
}